import {action, observable} from 'mobx';
import {databaseRef} from '../../helperFunctions/firebaseStore';
import {IBrand, IBrandAddData, IBrandEditData, IBrandsStore} from "../storeInterfaces/brandsStoreInterface";
import {convertObjToArray} from "./ordersStore";


export class BrandsStore implements IBrandsStore {

    @observable
    brands: IBrand[] = [];
    @observable
    loaded: boolean = false;
    @observable
    failed: boolean = false;

    @action
    editBrand = (brandId: string, dataToEdit: IBrandEditData) => {
        return databaseRef.ref('/brands/' + brandId).update(dataToEdit);
    };

    @action
    addBrand = (brandToAdd: IBrandAddData) => {
        const brandId = databaseRef.ref('/brands/').push(brandToAdd).key;
        return databaseRef.ref('/brands/' + brandId).set({...brandToAdd, brandId});
    };

    @action
    deleteBrand = (brandId: string) => {
        return databaseRef.ref('/brands/' + brandId).remove();
    };

    @action
    getBrandById = (brandId: string) => {
        return databaseRef.ref('/brands/' + brandId).once('value');
    };

    @action
    async getBrands() {
        try {
            await databaseRef.ref('/brands/').on('value', snapshot => {
                this.brands = snapshot ? convertObjToArray(snapshot.val()) : [];
                this.brands = this.brands.map(b => ({...b, edit: 'Edit', delete: 'Delete', id: b.brandId}))
                this.loaded = true;
            });
        } catch (e) {
            this.failed = true;
        }

    }
}